var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Language component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLanguage extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.414 2.73842C6.22106 3.45105 2.97428 6.94177 2.63399 11.2502H7.39823C7.67548 8.2003 8.71495 5.27405 10.414 2.73842ZM2.63399 12.7502C2.9743 17.0586 6.22104 20.5493 10.4139 21.262C8.71493 18.7263 7.67547 15.8001 7.39823 12.7502H2.63399ZM11.9893 22.8952C11.9923 22.8952 11.9954 22.8952 11.9985 22.8952C12.0011 22.8952 12.0037 22.8952 12.0062 22.8952C18.0203 22.8915 22.8945 18.0151 22.8945 12.0002C22.8945 5.98305 18.0166 1.10519 11.9995 1.10519C5.98235 1.10519 1.10449 5.98305 1.10449 12.0002C1.10449 18.0139 5.97684 22.8897 11.9893 22.8952ZM21.365 12.7502C21.0246 17.0594 17.7767 20.5506 13.5828 21.2624C15.2819 18.7266 16.3215 15.8003 16.5987 12.7502H21.365ZM21.365 11.2502C21.0246 6.94098 17.7767 3.44977 13.5827 2.73803C15.2819 5.27375 16.3214 8.20014 16.5987 11.2502H21.365ZM11.9985 20.9133C10.2651 18.5142 9.19709 15.6975 8.90497 12.7502H15.092C14.7999 15.6975 13.7319 18.5142 11.9985 20.9133ZM15.092 11.2502H8.90497C9.19709 8.30296 10.2651 5.48625 11.9985 3.0872C13.7319 5.48625 14.7998 8.30296 15.092 11.2502Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLanguage.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLanguage.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLanguage.prototype, "size", void 0);
if (customElements.get('cat-icon-language') === undefined) {
    customElements.define('cat-icon-language', BlocksIconLanguage);
}
